import { useAnalysisStats } from "@/queries/analysis"
import WidgetCommonContainer, {
  WidgetCommonFTUContainer,
} from "@/components/widgets/WidgetCommonContainer"
import BottomIcon from "@/assets/clipart/widgets/analyze-bottom-icon.svg"
import { WidgetWrapper } from "./WidgetWrapper"
import { router } from "expo-router"

import * as HomeEvents from "@/analytics/events/home"

export default function AnalyzeWidget() {
  const { data } = useAnalysisStats()
  const isFirstTimeUser: boolean = data?.userType === "firstTimeUser"
  const propertiesAnalyzedCount = data?.manualCount || 0
  // To test....
  // const isFirstTimeUser: boolean = true

  const ctaText = isFirstTimeUser
    ? `Get instant\ncomps for your\nanalysis`
    : `Analyze more\nproperties`

  const onPress = () => {
    HomeEvents.homepageWidgetClicked({
      nextScreen: "Analyze Property Search",
      widgetType: "widget-analyze",
      widgetState: isFirstTimeUser ? "zero-value" : "non-zero-value",
      widgetTitle: "Analyze",
      widgetCta: ctaText,
      widgetValue: !isFirstTimeUser
        ? propertiesAnalyzedCount.toString()
        : undefined,
    })

    router.push("/analyze")
  }

  return (
    <WidgetWrapper
      category="analyze"
      orientation="vertical"
      title="Analyze"
      onPress={onPress}
    >
      {isFirstTimeUser ? (
        <WidgetCommonFTUContainer
          headerText={ctaText}
          BottomIconComponent={BottomIcon}
        />
      ) : (
        <WidgetCommonContainer
          headerCount={propertiesAnalyzedCount.toString() || "0"}
          subTitle={`Properties analyzed\nlast 30 days`}
          ctaText={ctaText}
        />
      )}
    </WidgetWrapper>
  )
}
